import Row from './row';
import Col from './col';
export { Row, Col };


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/grid/index.js
// module id = 150
// module chunks = 0